import { CloseIcon } from "@komplett/design-system";
import classNames from "classnames";
import React from "react";

import { useSelector } from "../../utils/hooks";
import strings from "../../utils/strings";

import { DRAWER_HEADING_ID, HEADER_CONFIG, VARIANT } from "./Header.utils";

interface HeaderPropsI {
	closePopup: () => void;
}

export const Header = ({ closePopup }: HeaderPropsI) => {
	const showSubscriptionDataOnly = useSelector(
		(state) => state.popup.showSubscriptionDataOnly,
	);

	const header = showSubscriptionDataOnly ? "" : strings.popupAddToCart;

	const config = HEADER_CONFIG[VARIANT.DRAWER];

	return (
		<header
			className={classNames({
				[config.classNames.header]: true,
				"popup-info": !showSubscriptionDataOnly,
			})}
		>
			{header && (
				<div
					className={config.classNames.headingWrapper}
					data-testid="header-icon-checkmark"
				>
					<h1
						className={config.classNames.heading}
						data-testid="header-text"
						id={DRAWER_HEADING_ID}
					>
						{header}
					</h1>
				</div>
			)}
			<button
				type="button"
				onClick={closePopup}
				aria-label={strings.close}
				data-testid="header-button-close"
				className={classNames({
					[config.classNames.button]: true,
					"drawer-info": showSubscriptionDataOnly,
				})}
			>
				<CloseIcon size={20} />
			</button>
		</header>
	);
};
